import React from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import ReactDOM from 'react-dom'
import $ from 'jquery'
import 'datatables.net'
import 'datatables.net-responsive'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import { authHeader } from '../../_helpers'
import axios from 'axios';
import Spacer from 'react-add-space';

const { REACT_APP_API_URL :  API_URL} =process.env

class ContactModal extends React.Component {
  componentDidMount(){
       $('#contact').DataTable( {
        ordering: true,
        searching: true,
        processing: true,
        serverSide:true,
        bFilter: true,
        bInfo:true,
        bLengthChange: true,
        bPaginate:true,
        ordering: true,
        scrollCollapse: true,
        scrollY: true,
        scrollX: true,
        "ajax": {
          "url": `${API_URL}/api/contact_modal${this.props.query ? this.props.query : ''}`,
          "dataSrc" : 'data',
          "beforeSend": function (xhr) {
              xhr.setRequestHeader('Authorization',authHeader())
            }
          },
        columnDefs : [
            {
                'targets': [0],
                createdCell : (td, cellData, rowData, row, col) => {
                    ReactDOM.render(<React.Fragment><button className="btn btn-primary btn-sm" onClick={() => {this.Pilih(rowData[0],`${rowData[1]} - ${rowData[2]}`)}}>Pilih</button>
                      </React.Fragment>,td);
                }
            }
            
        ]
     } );
    }

   Pilih(id,name){
     const { Field1, Field2, onClick, onClose }= this.props
     onClick(Field1, name)
     onClick(Field2, id)
     onClose()
   } 

  render() {
    // Render nothing if the "show" prop is false
    if(!this.props.show) {
      return null;
    }

     const {onClose, top, bottom}= this.props
    const backdropStyle = {
    
      position: 'fixed', /* Stay in place */
      zIndex: 1, /* Sit on top */
      left: 0,
      top: 0,
      width: '100%', /* Full width */
      height: '100%', /* Full height */
      overflow: 'auto', /* Enable scroll if needed */
      backgroundColor: 'rgb(0,0,0)', /* Fallback color */
      backgroundColor: 'rgba(0,0,0,0.4)' /* Black w/ opacity */
    };

   
    return (
      <div className="modal-backdrop" style={backdropStyle}>
      <div className='animated fadeInRight'>
        <Modal.Dialog 
            size="lg"
            aria-labelledby="example-modal-sizes-title-lg"
            style={{top : 25}}
         >
         <Modal.Header>
        <Modal.Title>Cari Kontak</Modal.Title>
        </Modal.Header>

        <Modal.Body>
                <table className="table table-striped" style={{whiteSpace: 'nowrap', width: '100%'}} id="contact">
                  <thead>
                      <tr>
                          <th></th>
                          <th>Kode</th>
                          <th>Nama</th>
                          <th>Alamat</th>
                          <th>Kota</th>
                          <th>No Telp</th>
                          <th>Cabang</th>
                          <th>NIK</th>
                      </tr> 
                  </thead>
                </table>
        </Modal.Body>

        <Modal.Footer>
            <Button variant="secondary" onClick={onClose}>Close</Button>
        </Modal.Footer>
        </Modal.Dialog>
      </div>
      </div>
    );
  }
}


export  { ContactModal };




